import styled from 'styled-components';
import Icon from 'js/components/common/Icon';
import { lightGrey3Color } from 'js/config/style';

export default styled(Icon)`
  color: ${lightGrey3Color};
  align-self: center;
  justify-self: center;
`;
